<template>
  <list-page>
    <h1 slot="model">{{ banTitle.namez }}</h1>
    <h3 slot="model_y">{{ banTitle.namey }}</h3>
    <template slot="list">
      <list v-if="listData.length != 0" style="padding:0">
        <template slot="listitem">
          <div class="imgview">
            <router-link :to="'/ProductCategoryDetail/'+ item.id" target="_blank"
              v-for="(item,index) in listData" :key="index">
              <list-item :item="item"></list-item>
            </router-link>
          </div>
          <el-divider></el-divider>
        </template>
      </list>
      <el-empty v-else description="暂无信息"></el-empty>
      <page :total="total" :page-size="pageSize" :current-page="currentPage" @pageChange="getData" ></page>
    </template>
  </list-page>
</template>
  
<script>
  import listPage from '@/view/components/listPage.vue'
  import list from '@/view/components/list.vue'
  import listItem from '@/view/components/listItemProduct.vue'
  import page from '@/view/components/page.vue'

import News from '@/api/api.js'

export default {
  data() {
    return {
      listData: [],
      banTitle: {},
      total: 0,
      pageSize: 6,
      currentPage: 1
    };
  },
  components: {
    listPage,
    list,
    listItem,
    page
  },
  created() {
    this.modelChange()
  },
  watch: {
   $route(to,from){
    this.modelChange()
   }
  },
  methods: {
    async getData(page){
      this.currentPage = page
      this.searchDTO={
        page,   //页数
        limit: this.pageSize,
        classId: this.model  //新闻分类
      };
      let res = await News.getProductList(this.searchDTO);
      // console.log(res)
      this.listData = res.data;
      this.total = res.count
    },
    modelChange() {
      this.model = this.$route.params.model
      // console.log('this.model',this.model)
      if(this.model==1){
        this.banTitle = {
          namez: '产品分类-整车控制器',
          namey: 'Vehicle-controller'
        }
      }
      if(this.model==2){
        this.banTitle = {
          namez: '产品分类-电驱动与传动系统',
          namey: 'Electric-drive-and-transmission-system'
        }
      }if(this.model==3){
        this.banTitle = {
          namez: '产品分类-高压集成控制器',
          namey: 'High-voltage-integrated-controller'
        }
      }
      if(this.model==4){
        this.banTitle = {
          namez: '产品分类-其他高压附件',
          namey: 'Other-high-voltage-accessories'
        }
      }
      this.getData()
    },
  },
};
</script>
  
<style lang="scss"  scoped >
.list {
  padding: 0;
}
.imgview {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  &::after {
      content: ""; 
      width: calc((100% - 0px) / 3);
  }
  a {
    width: calc(100%/3);
    border-radius: 4px;
    transition: .6s;
    &:hover {
      background: rgba(0,0,0,0.3);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/webapp/ProductList.vue